import { gql } from '../../types/generated';

export const CREATE_PLAYBACK_OVERRIDE = gql(`
  mutation createPlaybackOverride(
    $experience: PlaybackExperience!
    $features: [PlaybackFeature!]!
    $matchParams: JSON!
  ) {
    createPlaybackOverride(experience: $experience, features: $features, matchParams: $matchParams)
  }
`);

export const UPDATE_PLAYBACK_OVERRIDE = gql(`
  mutation updatePlaybackOverride(
    $id: Int!
    $experience: PlaybackExperience!
    $features: [PlaybackFeature!]!
    $matchParams: JSON!
  ) {
    updatePlaybackOverride(id: $id, experience: $experience, features: $features, matchParams: $matchParams)
  }
`);

export const DELETE_PLAYBACK_OVERRIDE = gql(`
  mutation deletePlaybackOverride($overrideId: Int!) {
    deletePlaybackOverride(overrideId: $overrideId)
  }
`);
